import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step", "stepLabel", "dot"]
  static values = { initialStep: Number }

  connect() {
    this.currentStep = Math.max(0, (this.initialStepValue || 1) - 1)
    this.#updateIndicator()
    this.#showStep(this.currentStep)
  }

  next() {
    if (this.currentStep < this.stepTargets.length - 1) {
      this.currentStep++
      this.#showStep(this.currentStep)
      this.#updateIndicator()
      this.#saveStep()
    }
  }

  prev() {
    if (this.currentStep > 0) {
      this.currentStep--
      this.#showStep(this.currentStep)
      this.#updateIndicator()
      this.#saveStep()
    }
  }

  #showStep(index) {
    this.stepTargets.forEach((step, i) => {
      step.hidden = i !== index
    })
  }

  #saveStep() {
    const field = this.element.querySelector("input[name='consultation[current_step]']")
    if (!field) return
    field.value = this.currentStep + 1
    field.dispatchEvent(new Event("change", { bubbles: true }))
  }

  #updateIndicator() {
    const total = this.stepTargets.length
    const current = this.currentStep + 1

    if (this.hasStepLabelTarget) {
      this.stepLabelTarget.textContent = `Step ${current} of ${total}`
    }

    this.dotTargets.forEach((dot, i) => {
      dot.classList.toggle("bg-forest", i === this.currentStep)
      dot.classList.toggle("bg-sand", i !== this.currentStep)
    })
  }
}
